export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5130.0ed3b965.jpg";